"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cell = function Cell(props, context) {
  var column = props.column,
      data = props.data;
  var _column$props = column.props,
      component = _column$props.component,
      componentProps = _column$props.componentProps,
      renderer = _column$props.renderer,
      value = _column$props.value;


  var content = void 0;
  if (component) {
    content = (0, _react.createElement)(component, _extends({}, componentProps, { data: data }), context);
  } else if (renderer) {
    content = renderer(data);
  } else if (value) {
    if (typeof value === "string") {
      content = data.get(value);
    } else {
      content = data.getIn(value);
    }
  }

  var className = (0, _classnames2.default)("erg-components-Cell", {
    "text-muted": !content
  });
  return _react2.default.createElement(
    "td",
    { className: className },
    content || "--"
  );
};

Cell.displayName = "Cell";

Cell.propTypes = {
  column: _react.PropTypes.object,
  data: _react.PropTypes.instanceOf(I.Record)
};

exports.default = Cell;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/Cell.js
 ** module id = 395
 ** module chunks = 0
 **/